import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import DateTimeFieldDetail from "./detail";
import DateTimeFieldEdit from "./edit";
import DatetimeFieldList from "./list";
import "./datetime.css";
/** <b>Composant qui contient l'affichage d'un champ de type Datetime en: </b>
 * <li>Liste</li>
 * <li>Détails</li>
 * <li>Édition</li>
 */
export function Datetime() {
    return _jsx(_Fragment, { children: "Datetime" });
}
var field = fieldsType.datetime;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, DateTimeFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, DateTimeFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, DatetimeFieldList);
